export const inr = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const CYLINDERS = [
  { code: "DOM_14_2", label: "14.2 KG Domestic", short: "14.2kg" },
  { code: "COM_19", label: "19 KG Commercial", short: "19kg" },
  { code: "KG_5", label: "5 KG", short: "5kg" },
  { code: "FTL_5", label: "FTL (5 KG Full)", short: "FTL" },
];

export const cylLabel = (code) => CYLINDERS.find((c) => c.code === code)?.label || code;
export const cylShort = (code) => CYLINDERS.find((c) => c.code === code)?.short || code;

export const todayStr = () => new Date().toISOString().slice(0, 10);

// Displays an ISO date (yyyy-mm-dd, optionally with time) as Indian dd-mm-yyyy.
export const fmtDate = (s) => {
  if (!s) return "";
  const m = String(s).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return s;
};
